import "./ResetPassword.css";
import ArrowRight from "../../assets/icons/ArrowRight.svg";
import { Link } from "react-router-dom";
import FallbackImg from "../../components/FallbackImg";
import ApiService from "../../components/Api_services";
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import MultiPurpose from "../../components/multipurpose/MultiPurpose";
const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);
   const [modalProps, setModalProps] = useState({});
  const query = new URLSearchParams(location.search);
  const token = query.get("token") || "";
  const [fieldError, setFieldError] = useState("");

  let email = "";
  let validation = "";
  try {
    const decoded = atob(token);
    const arr = decoded.split("||");
    email = arr[0];
    validation = arr[1];
  } catch (e) {
    setModalProps({
      title: "Invalid Link",
      message: "Invalid or expired reset link.",
      yesText: "Back",
      showYesLink: true,
      yesLink: "/login",
      onClose: () => setShowModal(false)
    });
    setShowModal(true);
  }

  const handleSubmit = async () => {
    setFieldError("");
    setMsg("");
    if (!password || !confirm) {
      setFieldError("Please fill in all fields.");
      return;
    }
    if (password !== confirm) {
      setFieldError("Passwords do not match.");
      return;
    }
    if (!email || !validation) {
      setFieldError("Invalid or expired reset link.");
      return;
    }
    setLoading(true);
    // console.log("Resetting password for:", email, "with validation:", validation, "and new password:", password);
   try {
    const res = await ApiService.resetPassword(email, validation, password);
    if (res.status === "success") {
      setModalProps({
        title: "Reset Successful",
        message: "Your password has been reset. Please login again.",
        yesText: "Go to Login",
        showYesLink: true,
        yesLink: "/login",
        onClose: () => setShowModal(false)
      });
      setShowModal(true);
      setFieldError("");
    } else {
      setFieldError(res.message || "Failed to reset password.");
    }
  } catch (err) {
    setFieldError("Error, please try again.");
  }
    setLoading(false);
  };

  return (
    <div className="resetpassword">
      <div className="resetpassword-content">
        <div>
          <Link to="/login" className="rpback-button">
            <FallbackImg
              src={ArrowRight}
              alt="arrowright"
              width="18"
              height="18"
            />
            <strong>Back</strong>
          </Link>
        </div>
        <div className="resetpassword-input-container">
          <div className="resetpassword-input">
            <div className="resetpassword-title">
              <strong>Reset Password</strong>
            </div>
             <div>
              New Password <span>*</span>
              <input
                type="password"
                placeholder="Enter new password"
                value={password}
                onChange={e => setPassword(e.target.value)}
              />
            </div>
            <br />
            <div>
              Confirm Password <span>*</span>
              <input
                type="password"
                placeholder="Enter confirm password"
                value={confirm}
                onChange={e => setConfirm(e.target.value)}
              />
            </div>
            {fieldError && (
              <div style={{ color: "red", marginTop: 8 }}>{fieldError}</div>
            )}
            <button onClick={handleSubmit} disabled={loading}>
              {loading ? "Processing..." : "SET PASSWORD"}
            </button>
            {msg && <div style={{ marginTop: 10, color: "red" }}>{msg}</div>}
          </div>
          {showModal && (
            <MultiPurpose {...modalProps} />
          )}
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
